<template>
  <div class="pa-4">
    <v-row dense class="mb-4 align-center">
      <v-col cols="12" md="3">
        <v-text-field v-model="fromDate" type="date" label="Từ ngày" outlined dense hide-details />
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field v-model="toDate" type="date" label="Đến ngày" outlined dense hide-details />
      </v-col>
      <v-col cols="12" md="3">
        <v-btn color="primary" depressed @click="fetchReport" :loading="loading">
          <v-icon left small>mdi-magnify</v-icon> Tra cứu thẻ kho
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="reportData"
      :loading="loading"
      no-data-text="Không có dữ liệu trong khoảng thời gian này"
      dense
      class="elevation-1"
    >
      <template v-slot:item.openingStock="{ item }">
        <span class="font-weight-medium grey--text text--darken-2">{{ item.openingStock }}</span>
      </template>
      <template v-slot:item.totalImport="{ item }">
        <span class="font-weight-bold success--text">+{{ item.totalImport }}</span>
      </template>
      <template v-slot:item.totalExport="{ item }">
        <span class="font-weight-bold error--text">-{{ item.totalExport }}</span>
      </template>
      <template v-slot:item.closingStock="{ item }">
        <span class="font-weight-bold primary--text">{{ item.closingStock }}</span>
      </template>
      <template v-slot:item.availableStock="{ item }">
        <v-chip x-small color="teal" dark>{{ item.availableStock }}</v-chip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { AssetTransaction } from '@/plugins/api'

const headers = [
  { text: 'Mã thiết bị', value: 'assetCode', align: 'left', sortable: false },
  { text: 'Tên thiết bị', value: 'assetName', align: 'left', sortable: false },
  { text: 'Danh mục', value: 'categoryName', align: 'left', sortable: false },
  { text: 'ĐVT', value: 'unit', align: 'center', sortable: false },
  { text: 'Tồn đầu kỳ', value: 'openingStock', align: 'center', sortable: false },
  { text: 'Tổng nhập (+)', value: 'totalImport', align: 'center', sortable: false },
  { text: 'Tổng xuất (-)', value: 'totalExport', align: 'center', sortable: false },
  { text: 'Tồn cuối kỳ', value: 'closingStock', align: 'center', sortable: false },
  { text: 'Khả dụng', value: 'availableStock', align: 'center', sortable: false }
]

export default {
  name: 'StockReportView',
  data() {
    const today = new Date().toISOString().substring(0, 10)
    const firstDay = `${today.substring(0, 7)}-01`
    return {
      headers,
      fromDate: firstDay,
      toDate: today,
      loading: false,
      reportData: []
    }
  },
  async created() {
    await this.fetchReport()
  },
  methods: {
    async fetchReport() {
      this.loading = true
      try {
        const res = await AssetTransaction.getStockReport({
          fromDate: this.fromDate,
          toDate: this.toDate
        })
        this.reportData = (res && res.data) || []
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
